const common = {
  Save: 'บันทึก',
  Test: 'Test',
  en: 'English',
  'zh-hant': '繁體中文',
  'zh-cn': '简体中文',
  vi: 'Tiếng Việt',
  th: 'ไทย',
  ja: '日本語',
};

export default common;
